<!-- 发送邮件公共弹窗 -->
<template>
  <el-dialog
    v-el-drag-dialog
    no="sendEmail"
    :visible.sync="innerVisible"
    :title="$t('SeaExport.SendEMail')"
    width="950px"
    :append-to-body="appendToBody"
    :close-on-click-modal="false"
    class="app-main-inner settlement-select-dialog"
  >
    <el-form class="app-main-inner-row" style="flex-direction: column;padding-bottom: 10px;align-items: center">
      <div>
        <el-radio-group v-model="customerType" no="customerType" @change="otherHandler()">
          <el-radio :label="1">{{ $t('SeaExport.Customer') }}</el-radio>
          <el-radio :label="2">{{ $t('SeaExport.ShippingCmp') }}</el-radio>
          <el-radio :label="3">{{ $t('SeaExport.BookingAgent') }}</el-radio>
          <el-radio :label="4">{{ $t('SeaExport.LocalAgent') }}</el-radio>
          <el-radio :label="5">{{ $t('SeaExport.UpDestAgent') }}</el-radio>
          <el-radio :label="6">{{ $t('SeaExport.NominatedAgent') }}</el-radio>
          <el-radio :label="7">{{ $t('SeaExport.Haulage') }}</el-radio>
          <el-radio :label="8">{{ $t('SeaExport.Warehouse') }}</el-radio>
          <el-radio :label="9">{{ $t('SeaExport.EmailGroup') }}</el-radio>
          <el-radio :label="10">{{ $t('Message.Shipper') }}</el-radio>
          <el-radio :label="11">{{ $t('Message.Consignee') }}</el-radio>
          <el-radio :label="12">{{ $t('Message.Notify') }}</el-radio>
        </el-radio-group>
      </div>
      <el-form label-width="90px" label-position="left" style="width: 100%;margin: 0 auto;padding-top:5px">
        <el-form-item v-if="source === '7' && job.sentDestinationPortAgentDate && customerType === 5">
          <span><i class="el-icon-warning" style="color: #E6A23C;font-size: 14px;margin-right: 5px;" />{{ job.sentDestinationPortAgentDate }}{{ $t('Message.SentDestinationPortAgentTip') }}</span>
        </el-form-item>
        <el-form-item v-if="!isEmailGroup" :label="$t('SeaExport.CompanyName')">
          <cargo-company-select
            no="customerId"
            :method-params="{[customerTypeName]:true}"
            :default-value="customerId||''"
            style="width: 100%"
            @change="customerIdChange"
          />
        </el-form-item>
        <el-form-item v-if="!isEmailGroup" :label="$t('SeaExport.Receiver2')">
          <el-select v-model="emailToList" no="to" :filterable="true" multiple allow-create @clear="onClear" @change="emailToChange">
            <el-option
              v-for="(item,index) in contactList"
              :key="index"
              :label="item.name"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="isEmailGroup" class="long placeholder-margin" :label="$t('SeaExport.Email')">
          <el-select
            v-model="emailGroupTo"
            no="emailGroupTo"
            :filterable="true"
            multiple
            :clearable="true"
            @clear="onClear"
            @change="emailGroupToChange"
          >
            <el-option
              v-for="(item,index) in emailGroupToList"
              :key="index"
              :label="item.groupName"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="emailGroup" class="long placeholder-margin" :label="$t('SeaExport.Cc') + $t('SeaExport.EmailGroup')">
          <el-select
            v-model="emailGroupCc"
            no="emailGroupCc"
            :filterable="true"
            multiple
            :clearable="true"
            @clear="onClearCc"
            @change="emailGroupCcChange"
          >
            <el-option
              v-for="(item,index) in emailGroupCcList"
              :key="index"
              :label="item.groupName"
              :value="item.uuid"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.Cc')">
          <el-input v-model="emailForm.cc" no="cc" type="textarea" :rows="5" />
        </el-form-item>
        <div>
          <el-checkbox v-model="sales" no="sales" @change="ccChangeHandler('sales',sales)">{{ $t('SeaExport.Sales') }}</el-checkbox>
          <el-checkbox v-model="op" no="op" @change="ccChangeHandler('op',op)">{{ $t('SeaExport.Operation') }}</el-checkbox>
          <el-checkbox v-model="csr" no="csr" @change="ccChangeHandler('csr',csr)">{{ $t('SeaExport.CustomerService') }}</el-checkbox>
          <el-checkbox v-model="doc" no="doc" @change="ccChangeHandler('dc',doc)">{{ $t('SeaExport.Documents') }}</el-checkbox>
          <el-checkbox v-model="emailGroup" no="emailGroup" @change="ccChangeHandler('emailGroup', emailGroup)">{{ $t('SeaExport.EmailGroup') }}</el-checkbox>
          <template v-if="isSeBooking">
            <el-checkbox v-model="siteOP" no="siteOP" @change="ccChangeHandler('siteOP',siteOP)">{{ $t('SeaExport.FieldOperation') }}</el-checkbox>
            <el-checkbox v-model="overseaOp" no="overseaOp" @change="ccChangeHandler('overseaOp',overseaOp)">{{ $t('SeaExport.OverseaCustomerService') }}</el-checkbox>
            <el-checkbox v-model="planner" no="planner" @change="ccChangeHandler('planner',planner)">{{ $t('SeaExport.AirlinePerson2') }}</el-checkbox>
            <el-checkbox v-model="userDefinedRoleId1" no="userDefinedRoleId1" @change="ccChangeHandler('userDefinedRoleId1',userDefinedRoleId1)">{{ $t('CargoMsg.Cargo_userDefinedRole1') }}</el-checkbox>
            <el-checkbox v-model="userDefinedRoleId2" no="userDefinedRoleId2" @change="ccChangeHandler('userDefinedRoleId2',userDefinedRoleId2)">{{ $t('CargoMsg.Cargo_userDefinedRole2') }}</el-checkbox>
          </template>
          <el-checkbox v-model="defaultCc" no="defaultCc">{{ $t('SeaExport.SaveTheDefaultCC') }}</el-checkbox>
        </div>

        <el-form-item :label="$t('SeaExport.mailTemplate')">
          <div style="display:flex;margin-bottom:8px;">
            <el-checkbox v-model="emailTemplate" no="emailTemplate" @change="emailTemplateCheck" />
            <span style="flex:1;margin-left: 10px;">
              <cargo-combo-box
                v-model="themeTemplate"
                no="themeTemplate"
                :disabled="!emailTemplate"
                :allow-create="true"
                :clearable="true"
                :options="emailTemplateList"
                :label-function="titleLabelFunction"
                :placeholder-val="$t('SeaExport.placeholderVal')"
                value-field="uuid"
                :forbid-values="['']"
                @change="emailTemplateChange"
                @clear="onClearTitle"
              />
            </span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('SeaExport.emailSubject')">
          <span style="display: flex;">
            <el-input v-model="emailForm.title" no="title" />
          </span>
        </el-form-item>

        <!-- 邮件内容 -->
        <el-form-item v-show="source === '7' || source === '4'" style="height:auto;" :label="$t('SeaExport.MailContent')">
          <quill-editor
            v-model="emailForm.mailContent"
            no="mailContent"
            :options="editorOption"
            style="height: auto"
            class="my-custom-quill-editor-send-email"
          />
        </el-form-item>
        <el-form-item v-show="source !== '7' && source !== '4'" :label="$t('SeaExport.MailContent')">
          <el-input v-show="showContent" v-model="emailForm.content" no="content" type="textarea" :rows="5" />
          <el-input v-show="!showContent" v-model="tempStr" no="tempStr" type="textarea" :rows="5" />
        </el-form-item>

        <!-- 发送邮件 -->
        <el-form-item v-if="source === '7' || source === '4'" class="long" :label="$t('SeaExport.SendEMail')">
          <el-select v-model="emailForm.mailType" no="mailType" :placeholder="$t('SeaExport.SystemEmail')">
            <el-option v-for="(item, index) in sendEmailList" :key="index" :label="item.name" :value="item.id" />
          </el-select>
        </el-form-item>

        <!-- V3发送邮件附件框 -->
        <el-form-item v-if="source === '4'" class="long" :label="$t('SeaExport.attachment')">
          <div style="display:flex;">
            <el-input v-model="templateName" no="templateName" clearable @input="paste" />
          </div>
        </el-form-item>

      </el-form>
    </el-form>
    <div slot="footer" style="margin: 0 auto;width: fit-content;">
      <el-button v-show="source === '4'" no="preview" type="primary" plain @click="sendMailPreview">{{ $t('SeaExport.preview') }}</el-button>
      <el-button no="invokeLocalMailClient" type="primary" plain @click="localEmailClickHandler">{{ $t('SeaExport.InvokeLocalMailClient') }}</el-button>
      <el-button no="confirm" type="primary" @click="okClickHandler">{{ $t('CargoMsg.Cargo_Send') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fileHistorySendEmailService } from '@/api/sendEmailService'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { sendMail, getSetMailTemplate } from '@/api/sendEmailService'
import { Company } from '@/class/model/mdm/Company'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as userApi from '@/api/user'
import { resolveSpecificField2Value } from '@/utils/basicDataCache'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getMailGroupList } from '@/api/basicData/mailGroup'
import CargoComboBox from '@/components/Cargo/Common/cargoComboBox'
import LocalStorageUtils from '@/utils/localStorageUtils'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { quillEditor } from 'vue-quill-editor'
export default {
  name: 'SendEmailDialog',
  components: { CargoComboBox, cargoAdvanceSelect, cargoCompanySelect, quillEditor },
  props: {
    visible: { type: Boolean, required: true },
    context: {
      type: Object,
      default: null,
      required: false
    },
    job: {
      type: Object,
      required: true
    },
    sendEmailData: {
      type: Object,
      required: true
    },
    fileIdList: {
      type: String,
      default: '',
      required: false
    },
    sendCallBack: {
      type: Function,
      required: false,
      default: null
    },
    showContent: {
      type: Boolean,
      required: false,
      default: true
    },
    pushLink: {
      type: Number,
      default: 0
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    v3entrance: {
      type: String,
      default: ''
    },
    source: {
      type: String,
      required: false,
      default: ''
    },
    jobUuidList: {
      type: Array,
      default: null
    },
    v3mail: {
      type: Object,
      required: false
    },
    viewSource: { // 页面请求发起方
      type: String,
      default: ''
    }
  },
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: {
            container: [
              /* eslint-disable */
              ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
              ["blockquote", "code-block"], // 引用  代码块
              [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
              ["clean"], // 清除文本格式
            ]
          }
        }
      },
      test: '',
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      customerType: 1,
      customerTypeName: 'customer',
      contactList: [],
      customerId: this.job.customerId,
      ccList: [],
      sales: false,
      op: false,
      csr: false,
      doc: false,
      siteOP: false,
      overseaOp: false,
      planner: false,
      userDefinedRoleId1: false,
      userDefinedRoleId2: false,
      emailGroup: '', // 抄送邮件群组
      defaultCc: false,
      themeTemplate: '', // 选中的邮件模板
      emailGroupTo: [], // 收件人邮件群组
      emailGroupCc: [], // 抄送邮件群组
      contactEmailCc: [], // 联系人抄送邮件
      emailTemplate: '', // 邮件模板是否勾选
      emailTemplateList: [], // 邮件模板
      emailToList: [], // 收件人邮件集合uuid
      emailGroupToList: [], // 收件人邮件群组
      emailGroupCcList: [], // 抄送人邮件群组
      tempStr: '', // 临时变量无用
      stream: '', // V3文件流
      templateName: '', // V3文件名称
      jobUuidStr: '',
      storageFileId: '',
      emailForm: {
        to: '',
        cc: '',
        title: '',
        content: '',
        ids: '',
        pushLink: '',
        mailType: '0',
        officeId: this.$store.getters.currentOfficeId,
        mailContent: ''
      },
      sendEmailList: [
        {
          name: this.$t('SeaExport.SystemEmail'),
          id: '0'
        }
      ],
      changeCustomerType: false // 是否修改
    }
  },
  computed: {
    isEmailGroup() {
      return this.customerType && Number(this.customerType) === 9
    },
    isSeBooking() {
      return this.viewSource === 'SeBooking'
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.innerVisible = true
    }
    const localCustomerType = LocalStorageUtilsNew.getConfiguration(this.source + 'default_SendEmailDialog')
    if (localCustomerType) {
      this.customerType = localCustomerType
    }
    await this.initEmailGroupList()
    this.initEmailTemplateList()
    this.changeCustomerType = false
    let localObj = LocalStorageUtilsNew.getConfiguration(this.source + 'SendEmailDialog' + this.customerType)
    if (!localObj) {
       localObj = LocalStorageUtilsNew.getConfiguration(this.source + 'SendEmailDialog')
    }
    if (localObj) { // 优先取SendEmailDialog缓存
      // 加载缓存相关数据
      this.doLocalCache(localObj)
    } else if(localCustomerType && this.customerType){ // 取default_SendEmailDialog缓存
      this.changeHandler()
    } else { // 没有则默认取客户的联系人
      await this.initContactList({ cmpIdx: this.customerId })
    }
    if (!this.emailTemplate) {
      this.emailForm.title = this.sendEmailData.emailTitle
    }
    this.emailForm.ids = this.sendEmailData.fileIdList
    if (this.source !== '4') {
      this.attachList = [...this.sendEmailData.fileList]
    }
    if (!localObj) {
      await this.reloadDefaultEmailChange()
    }
    // 7 文件历史 4 V3打印发送邮件
    if (this.source === '7' || this.source === '4') {
      this.emailForm.pushLink = this.source
      let templateUuid = ''
      this.emailTemplate = LocalStorageUtils.getConfiguration(`emailTemplate${this.source}`)
      templateUuid = LocalStorageUtils.getConfiguration(`templateUuid${this.source}`)
      if (this.emailTemplate) {
        this.themeTemplate = LocalStorageUtils.getConfiguration(`themeTemplate${this.source}`)
      }
      this.getSetMailTemplateFunc(templateUuid)
      this.getEamilStatus()
    }
  },
  methods: {
    // V3发送邮件时，处理手动ctrl+v的内容
    paste(val) {
      // 获取到的是','分割的字符串，分割完成后数组第一项为附件名称，第二项为发送pdf的数据流
      const pasteArr = val.split(',')
      this.templateName = ''
      this.stream = ''
      if (pasteArr[1]) {
        this.templateName = `${pasteArr[0]}.pdf`
        this.stream = pasteArr[1]
      }
    },
    // V3附件预览跳转到V3模块，调用父组件内的方法跳转
    sendMailPreview() {
      this.$emit('sendMailPreview', 'preview')
    },
    // 获取邮件内容
    async getSetMailTemplateFunc(templateUuid) {
      // this.jobUuidList存在时为批量打印，获取批量勾选的数据的jobUuid，放在数组中，通过join以','分割成字符串
      // 传递给后端，不是批量勾选，则直接获取jobUuid
      if (this.jobUuidList) {
        this.jobUuidStr = this.jobUuidList.join(',')
      } else if(this.job){
        if(this.job._data.jobUuid){
          this.jobUuidStr = this.job._data.jobUuid
        } else {
          this.jobUuidStr = this.job._data.uuid
        }
      }
      const data = {
        jobUuid: this.jobUuidStr,
        pushLink: this.source
      }
      // 当为V3发送且选择多门点时，启用该参数，获取到门点的uuid 该值为对象结构{key:value}
      if (templateUuid) {
        data.templateUuid = templateUuid
      }
      // 当为V3发送且选择多门点时，启用该参数，获取到门点的uuid 该值为对象结构{key:value}
      if (this.v3mail) {
        data.currentDateMap = this.v3mail
      }
      const res = await getSetMailTemplate(data)
      if (res.ok) {
        // 获取到的邮件内容
        if (this.emailTemplate) {
          this.emailForm.title = res.data.themeTemplate
        }

        this.emailForm.content = res.data.contentTemplate ? res.data.contentTemplate.replace(/ /g, '&nbsp;') : ''
        this.emailForm.mailContent = res.data.contentTemplate ? res.data.contentTemplate.replace(/ /g, '&nbsp;') : ''
      }
    },
    // 获取发送邮箱可勾选项
    async getEamilStatus() {
      //  enable：0未启用 1启用，获取当前已启用的邮箱数据
      const data = {
        branchId: this.$store.getters.currentOfficeId,
        enable: 1
      }
      const personalInfo = await userApi.getPersonalEmail(data).then(resp => resp.data)
      if (personalInfo) {
        personalInfo.map((item) => {
          switch (item.mailType) {
            case '1':
              this.sendEmailList.push({
                name: this.$t('SeaExport.CompanyMail'),
                id: '1'
              })
              break
            case '2':
              this.sendEmailList.push({
                name: this.$t('SeaExport.PersonalMailbox'),
                id: '2'
              })
              break
          }
        })
      }
    },
    selectBlur(e) {
      this.emailForm.to = e.target.value
    },
    // 等同于cargoware 中的 方法 loadContactsResultHandler
    async customerIdChange(company) {
      this.changeCustomerType = true
      this.emailForm.to = ''
      this.contactList = null
      this.getCompany(company)
    },
    getCompany(company) {
      this.emailToList = null
      this.loadContactsResultHandler(company)
    },
    async loadContactsResultHandler(company) {
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      this.buildContactsData(contacts)
    },
    getCarrierCompany(company) {
      this.emailForm.to = ''
      this.contactList = null
      this.emailToList = null
      this.loadCarrierContactsResultHandler(company)
    },
    async loadCarrierContactsResultHandler(company) {
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      if (contacts == null || contacts.length === 0) {
        if(this.changeCustomerType){
          this.clearContactEmailCc()
          // 设置邮件群组抄送人
          if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
            this.emailGroupCcChange(this.emailGroupCc)
          } else {
            // 刷新CC内容
            this.refreshCcTxt()
          }
        }
        return
      }
      const newContactList = []
      const vesselLineEmailList = []
      // 获取航线代码
      const vesselLine = this.getVesselLine()
      for (const contact of contacts) {
        const item = this.convertContactToEmail(contact)
        if (vesselLine !== '' && contact.airline === vesselLine) {
          vesselLineEmailList.push(item)
        } else {
          newContactList.push(item)
        }
      }
      if (vesselLineEmailList !== null && vesselLineEmailList.length > 0) {
        this.contactList = vesselLineEmailList
        const emailItem = this.contactList[0]
        const email = this.contactList[0].email
        this.emailForm.to = email
        this.addEmailToList(emailItem)
        this.setDefaultCc(emailItem)
        // 设置邮件群组抄送人
        if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
          this.emailGroupCcChange(this.emailGroupCc)
        } else {
          // 刷新CC内容
          this.refreshCcTxt()
        }
      } else if (newContactList !== null && newContactList.length > 0) {
        this.contactList = newContactList
        const emailItem = this.contactList[0]
        const email = this.contactList[0].email
        this.emailForm.to = email
        this.addEmailToList(emailItem)
        this.setDefaultCc(emailItem)
        // 设置邮件群组抄送人
        if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
          this.emailGroupCcChange(this.emailGroupCc)
        } else {
          // 刷新CC内容
          this.refreshCcTxt()
        }
      }
    },
    // 部分邮件实体实际没有email，但是页面上要显示用户名称
    addEmailToList(emailItem) {
      if (!this.emailToList) {
        this.emailToList = []
      }
      const i = this.emailToList.findIndex(item => item.uuid === emailItem.uuid)
      if (i < 0) {
        this.emailToList.push(emailItem.uuid)
      }
    },
    /* 车队信息*/
    loadTruckingResultHandler() {
      // todo 业务信息暂未获取车队信息
      // this.customerId = this.job.trucking[0]
      this.getCompany({ cmpIdx: this.customerId })
    },
    /* 查询内装仓库信息*/
    loadWarehouseSuccess() {
      // todo 业务信息暂未获取仓库信息
      // this.customerId = this.job.warehouseInfo[0]
      this.getCompany({ cmpIdx: this.customerId })
    },
    /* 初始时赋值收件人(联系人)*/
    async initContactList(company) {
      this.emailToList = []
      company = new Company(company)
      const contacts = await company.getContactsBycmpIdx()
      this.buildContactsData(contacts)
    },
    getVesselLine() {
      const region = resolveSpecificField2Value(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode, 'region')
      return region
    },
    buildContactsData(contacts) {
      // 获取job 上的联系人
      const defaultContactObj = this.getDefaultEmail(contacts)
      const newContactList = []
      let defalutContactEmail = ''
      let defalutContactEmailItem = null
      if (contacts && contacts.length > 0) {
        for (const item of contacts) {
          const obj = {
            name: `[${item.contactPerson}]${item.email}`,
            contact: item.contactPerson,
            email: item.email,
            uuid: item.uuid,
            ccAddress: item.ccAddress
          }
          if (defaultContactObj && defaultContactObj.name === obj.name) {
            defalutContactEmail = item.email
            defalutContactEmailItem = obj
          }
          newContactList.push(obj)
        }
      }
      this.contactList = newContactList
      if (!(this.contactList && this.contactList.length > 0)) {
        if(this.changeCustomerType){
          this.clearContactEmailCc()
          // 设置邮件群组抄送人
          if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
            this.emailGroupCcChange(this.emailGroupCc)
          } else {
            // 刷新CC内容
            this.refreshCcTxt()
          }
        }
        return
      }
      if (defalutContactEmail !== '') {
        this.emailForm.to = defalutContactEmail
        this.addEmailToList(defalutContactEmailItem)
        // 设置默认抄送人
        this.setDefaultCc(defalutContactEmailItem)
      } else {
        const firstContact = this.contactList[0]
        this.addEmailToList(firstContact)
        this.emailForm.to = firstContact.email
        // 设置默认抄送人
        this.setDefaultCc(firstContact)
      }
      // 设置邮件群组抄送人
      if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
        this.emailGroupCcChange(this.emailGroupCc)
      } else {
        // 刷新CC内容
        this.refreshCcTxt()
      }
    },
    convertContactToEmail(contact) {
      const obj = {
        name: `[${contact.contactPerson}]${contact.email}`,
        contact: contact.contactPerson,
        email: contact.email,
        uuid: contact.uuid,
        ccAddress: contact.ccAddress || ''
      }
      return obj
    },
    async reloadDefaultEmailChange() {
      const ccItem = JSON.parse(window.localStorage.getItem('defaultCC'))
      if (ccItem !== null) {
        if (ccItem.hasOwnProperty('sales') && this.job.sales !== '') {
          this.sales = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('op') && this.job.op !== '') {
          this.op = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('csr') && this.job.csr !== '') {
          this.csr = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('doc') && this.job.dc !== '') {
          this.doc = true
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
          if (userEmail !== '') {
            this.ccList.push(userEmail)
          }
        }
        if (ccItem.hasOwnProperty('defaultCc')) {
          this.defaultCc = true
        }
      }
      // 如果自己有操作，销售，单证，客户权限则默认选中
      if (this.$checkPermission(['role_sales']) && this.job.sales !== '' && !this.sales) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        if (userEmail !== '') {
          this.sales = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_op']) && this.job.op !== '' && !this.op) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        if (userEmail !== '') {
          this.op = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_csr']) && this.job.csr !== '' && !this.csr) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        if (userEmail !== '') {
          this.csr = true
          this.ccList.push(userEmail)
        }
      }
      if (this.$checkPermission(['role_doc']) && this.job.dc !== '' && !this.doc) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        if (userEmail !== '') {
          this.doc = true
          this.ccList.push(userEmail)
        }
      }
      // 刷新CC内容
      this.refreshCcTxt()
    },
    refreshCcTxt(emailList) {
      let ccList = [...new Set(this.ccList)]
      if (emailList) {
        ccList = emailList
      }
      let ccEmail = ''
      for (let i = 0; i < ccList.length; i++) {
        if (ccEmail === '') {
          ccEmail = ccList[i]
        } else {
          ccEmail = ccEmail + ',\n' + ccList[i]
        }
      }
      this.emailForm.cc = ccEmail
    },
    /* 保存默认抄送人*/
    saveCCEmail() {
      const ccObject = {}
      if (this.defaultCc) {
        // eslint-disable-next-line eqeqeq
        if (this.sales && !this.job.sales !== '') {
          ccObject.sales = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        }
        if (this.op && !this.job.op !== '') {
          ccObject.op = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        }
        if (this.csr && !this.job.csr !== '') {
          ccObject.csr = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        }
        if (this.doc && !this.job.dc !== '') {
          ccObject.doc = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        }
        if (this.defaultCc) {
          ccObject.defaultCc = this.defaultCc
        }
      }
      window.localStorage.setItem('defaultCC', JSON.stringify(ccObject))
    },
    /* 邮件发送*/
    okClickHandler() {
      const loading = getLoading()
      if (!this.toCheckEmailForm()) {
        loading.close()
        return
      }
      this.toLocalCache()
      // 保存默认抄送人
      this.saveCCEmail()
      this.emailForm.cc = this.emailForm.cc.replace(/\n/g, '')
      // 文件历史
      if (this.source === '7' || this.source === '4') {
        this.emailForm.content = this.emailForm.mailContent.replace(/ /g, '&nbsp;')
      } else {
        if (!this.showContent) {
          this.emailForm.content = this.tempStr
        }
      }
      // V3打印模板发送邮件，调用其他发送邮件接口
      if (this.source === '4') {
        const data = {
          jobUuid: this.jobUuidStr,
          branchId: this.$store.getters.currentOfficeId,
          toEmailAddress: this.emailForm.to, // 收件邮箱
          content: this.emailForm.mailContent, // 邮件内容
          mailCc: this.emailForm.cc, // 抄送
          mailSubject: this.emailForm.title, // 邮件主题
          ...this.emailForm
        }
        if (this.templateName) {
          data.attachmentList = [
            {
              file: this.stream,
              fileName: this.templateName
            }
          ]
        }
        sendMail(data).then((res) => {
          if (res.ok) {
            this.innerVisible = false
            this.$message({
              type: 'success',
              message: this.$t(`Message.TheFileIsSentSuccessfully`)
            })
          } else {
            this.$message({
              type: 'info',
              message: this.$t('SeaExport.MailSendingFailed')
            })
          }
        }).finally(() => {
          loading.close()
        })
        return
      }
      const content = this.emailForm.content ? this.emailForm.content.split('\n').join('<br/>') : ''
      if (this.sendCallBack) {
        this.sendCallBack(this.emailForm.to, this.emailForm.cc, this.emailForm.title, content)
        loading.close()
        return
      }

      let toName = '';
      for (const contact of this.contactList) {
        if (contact.email === this.emailForm.to) {
          toName = contact.name
        }
      }

      const emailForm = {}
      Object.assign(emailForm, this.emailForm)
      emailForm.content = content
      emailForm.jobNo = this.job.jobNo
      emailForm.toName = toName, // 收件人姓名
      fileHistorySendEmailService(emailForm).then(res => {
        if (res.ok) {
          this.innerVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`Message.TheFileIsSentSuccessfully`)
          })
        } else {
          this.$message({
            type: 'info',
            message: this.$t('SeaExport.MailSendingFailed')
          })
        }
      }).catch(() => {
        // this.$message.error(err)
      }).finally(() => {
        loading.close()
      })
    },
    localEmailClickHandler() {
      // if (!this.toCheckEmailForm()) return
      this.toLocalCache()
      let defaultContent = ''
      if (this.sendEmailData.detailCode === 'Put Cabin') {
        const seletedContact = this.contactList.find(x => x.email === this.emailForm.to)
        defaultContent = 'Dear ' + seletedContact.contact + '\n'
        this.emailForm.title = this.$t('Message.ApplicationForRelease') + ColumnUtils.formateDateToString(this.job.etd, 'yyyy-MM-dd') + this.getVesselLine()
        this.emailForm.content = defaultContent + this.emailForm.content
      } else if (this.sendEmailData.detailCode === 'Apply Shipper') {
        this.emailForm.title = this.$t('Message.ApplyForShipperCode')
      }
      const content = this.emailForm.content ? this.emailForm.content.split('\n').join('<br/>') : ''
      parent.location.href = 'mailto:' + this.emailForm.to + '?subject=' + this.emailForm.title + '&cc=' + this.emailForm.cc + '&body=' + content
    },
    toCheckEmailForm: function() {
      let errorMsg = ''
      if (!this.emailForm.to) {
        errorMsg += this.$t('Message.EmailAddressCannotBeEmpty')
      }
      if (this.isEmailGroup && this.emailForm.to) { // 收件群组
        this.emailForm.to = this.emailForm.to.replaceAll('\n', '')
        this.emailForm.to = this.emailForm.to.replaceAll(';', ',')
      }
      if (this.emailGroup && this.emailForm.cc) { // 抄送群组
        this.emailForm.cc = this.emailForm.cc.replaceAll('\n', '')
        this.emailForm.cc = this.emailForm.cc.replaceAll(';', ',')
      }
      if (errorMsg) {
        this.$message.error(errorMsg)
        return false
      } else {
        return true
      }
    },
    // 做本地缓存
    toLocalCache() {
      if (!this.source) {
        return
      }
      // 记录了上次打开的是哪个页签
      LocalStorageUtilsNew.setConfiguration(this.source + 'default_SendEmailDialog', this.customerType)
      LocalStorageUtilsNew.setConfiguration(this.source + 'SendEmailDialog' + this.customerType, {
        customerType: this.customerType,
        customerTypeName: this.customerTypeName,
        sales: this.sales,
        op: this.op,
        csr: this.csr,
        doc: this.doc,
        siteOP: this.siteOP,
        overseaOp: this.overseaOp,
        planner: this.planner,
        userDefinedRoleId1: this.userDefinedRoleId1,
        userDefinedRoleId2: this.userDefinedRoleId2,
        emailGroup: this.emailGroup,
        defaultCc: this.defaultCc,
        emailGroupTo: this.emailGroupTo.join(','),
        emailGroupCc: this.emailGroupCc.join(','),
        cc: this.emailForm.cc,
        mailType: this.emailForm.mailType
      })
    },
    // 抄送信息改变
    ccChangeHandler(p, check) {
      // 邮件群组移除群组相关邮箱
      if (p === 'emailGroup' && !check) {
        this.emailForm.cc = ''
      }
      if (this.job[p] !== '') {
        const email = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job[p], 'email')
        if (check) {
          if (email !== '' && !this.ccList.includes(email)) {
            this.ccList.push(email)
          }
        } else {
          this.ccList = this.ccList.filter(value => {
            return value !== email
          })
        }
      }
      // 用户组勾选了 ，在把用户组加上
      if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
        this.emailGroupCcChange(this.emailGroupCc)
      } else {
        // 刷新CC内容
        this.refreshCcTxt()
      }
    },
    /* 客户类型选择*/
    changeHandler() {
      switch (this.customerType) {
        case 1:
          this.customerId = this.job.customerId
          this.customerTypeName = 'customer'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 2:
          this.customerId = this.job.carrierId
          this.customerTypeName = 'seaCmp'
          this.getCarrierCompany({ cmpIdx: this.customerId })
          break
        case 3:
          this.customerId = this.job.bookingAgent
          this.customerTypeName = 'bookingAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 4:
          this.customerId = this.job.localAgent
          this.customerTypeName = 'localAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 5:
          this.customerId = this.job.destinationAgent
          this.customerTypeName = 'overseaAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 6:
          this.customerId = this.job.designationAgent
          this.customerTypeName = 'designationAgent'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 7:
          this.customerTypeName = 'truckCmp'
          this.loadTruckingResultHandler()
          break
        case 8:
          this.customerTypeName = 'warehouse'
          this.loadWarehouseSuccess()
          break
        case 10:
          this.customerId = this.job.shipperId
          this.customerTypeName = 'shipper'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 11:
          this.customerId = this.job.consigneeId
          this.customerTypeName = 'consignee'
          this.getCompany({ cmpIdx: this.customerId })
          break
        case 12:
          this.customerId = this.job.notifyId
          this.customerTypeName = 'notify'
          this.getCompany({ cmpIdx: this.customerId })
          break
      }
    },
    /* 获取默认联系人*/
    getDefaultEmail(contacts) {
      if (contacts && contacts.length > 0) {
        for (const contact of contacts) {
          if (contact.contactPerson === this.job.customerContact) {
            const item = {
              name: `[${contact.contactPerson}]${contact.email}`,
              contact: contact.contactPerson,
              email: contact.email,
              ccAddress: contact.ccAddress
            }
            return item
          }
        }
      }
      return null
    },
    onClear(val) {
      this.emailForm.to = ''
    },
    // 获取当前用户有权限的群组
    async initEmailGroupList() {
      this.emailGroupToList = []
      this.emailGroupCcList = []
      const params = {}
      const checkOwner = this.$checkPermission(['role_MailGroup_userSelf']) // 查看自己的数据及公共的数据
      if (checkOwner) params.checkOwner = true
      const checkAll = this.$checkPermission(['role_MailGroup_all']) // 查看全部数据
      if (checkAll) params.checkAll = true
      await getMailGroupList(params).then(res => {
        const emailGroupList = res.data.list
        if (!emailGroupList || emailGroupList.length <= 0) return
        for (const group of emailGroupList) {
          if (group.groupSceneTo) {
            this.emailGroupToList.push(group)
          }
          if (group.groupSceneCc) {
            this.emailGroupCcList.push(group)
          }
        }
      })
    },
    doLocalCache(localObj) {
      this.customerType = localObj.customerType
      this.customerTypeName = localObj.customerTypeName
      this.sales = localObj.sales
      this.op = localObj.op
      this.csr = localObj.csr
      this.doc = localObj.doc
      this.siteOP = localObj.siteOP || false
      this.overseaOp = localObj.overseaOp || false
      this.planner = localObj.planner || false
      this.userDefinedRoleId1 = localObj.userDefinedRoleId1 || false
      this.userDefinedRoleId2 = localObj.userDefinedRoleId2 || false
      this.emailGroup = localObj.emailGroup
      this.defaultCc = localObj.defaultCc
      this.emailGroupTo = localObj.emailGroupTo ? localObj.emailGroupTo.split(',') : []
      this.emailGroupCc = localObj.emailGroupCc ? localObj.emailGroupCc.split(',') : []
      this.emailForm.mailType = localObj.mailType
      if (this.isEmailGroup && this.emailGroupTo && this.emailGroupTo.length > 0) {
        this.emailGroupToChange(this.emailGroupTo)
      }
      this.emailForm.cc = localObj.cc
      if (this.sales && this.job.sales) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.sales, 'email')
        if (userEmail) {
          this.ccList.push(userEmail)
        }
      }
      if (this.op && this.job.op) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.op, 'email')
        if (userEmail) {
          this.ccList.push(userEmail)
        }
      }
      if (this.csr && this.job.csr) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.csr, 'email')
        if (userEmail) {
          this.ccList.push(userEmail)
        }
      }
      if (this.doc && this.job.dc) {
        const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.dc, 'email')
        if (userEmail) {
          this.ccList.push(userEmail)
        }
      }
      if (this.isSeBooking) {
        if (this.siteOP && this.job.siteOP) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.siteOP, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
        if (this.overseaOp && this.job.overseaOp) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.overseaOp, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
        if (this.planner && this.job.planner) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.planner, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
        if (this.userDefinedRoleId1 && this.job.userDefinedRoleId1) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.userDefinedRoleId1, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
        if (this.userDefinedRoleId2 && this.job.userDefinedRoleId2) {
          const userEmail = resolveSpecificField2Value(TYPE_NAMES.basic_data_User, 'userId', this.job.userDefinedRoleId2, 'email')
          if (userEmail) {
            this.ccList.push(userEmail)
          }
        }
      }
      if (this.customerType) {
        this.changeHandler()
      }
      if (this.emailGroup && this.emailGroupCc && this.emailGroupCc.length > 0) {
        this.emailGroupCcChange(this.emailGroupCc)
      } else {
        // 刷新CC内容
        this.refreshCcTxt()
      }
    },
    otherHandler() {
      // 修改发送对象类型，此时标记一下。 用来判断是否需要清空抄送人地址信息
      this.changeCustomerType = true
      // 切换推送对象时，切换邮件模版
      this.initEmailTemplateList()
      const localObj = LocalStorageUtilsNew.getConfiguration(this.source + 'SendEmailDialog' + this.customerType)
      if (localObj) {
        this.ccList = []
        this.doLocalCache(localObj)
      } else {
        // 原切换方法
        this.changeHandler()
      }
    },
    // 获取当前分公司的邮件模板
    initEmailTemplateList() {
      this.emailTemplateList = []
      const data = {
        multipleOfficeIdList: [this.job.opOffice],
        branchId: this.$store.getters.currentOfficeId,
        lob: this.job.lob,
        multipleAccountIdList: [this.customerType],
        pushLink: this.pushLink
      }
      userApi.getMailTemplateByParams(data).then((res) => {
        this.emailTemplateList = res.data || []
        // 如果已经有邮件模版 ，检查下新列表有没有，没有就删了
        if (this.emailForm && this.themeTemplate) {
          const has = this.emailTemplateList.filter(p => String(p.templateName) === String(this.themeTemplate))
          if (!has || has.length === 0) {
            this.themeTemplate = ''
            this.emailTemplateChange()
          }
        }
      })
    },
    // 收件人邮件群组改变
    emailGroupToChange(items) {
      const emails = []
      for (const option of this.emailGroupToList) {
        if (items.includes(option.uuid) && option.emailAddress) {
          const items = option.emailAddress.split('\n')
          for (const item of items) {
            if (!emails.includes(item)) {
              emails.push(item.replaceAll(';', ','))
            }
          }
        }
      }
      this.emailForm.to = emails.join('\n')
    },
    emailToChange(val) {
      const emails = []
      for (const data of val) {
        for (const option of this.contactList) {
          if (data === option.uuid && option.email) {
            emails.push(option.email.replaceAll(';', ','))
            this.setDefaultCc(option)
          } else if (data.includes('@') && !emails.includes(data)) {
            emails.push(data)
          }
        }
      }
      this.emailForm.to = emails.join(',')
      // 联系人全部清空时，同步清空抄送人
      if (!val || val.length === 0) {
        for (const email of this.contactEmailCc) {
          this.ccList = this.ccList.filter(value => {
            return value !== email
          })
        }
        this.contactEmailCc = []
      }
      // 刷新CC内容
      this.refreshCcTxt()
    },
    // 抄送邮件群组改变
    emailGroupCcChange(items) {
      // 去除重复的
      const ccList = [...new Set(this.ccList)]
      // 默认添加上已经选择的其他类型抄送人
      let emails = ccList ? ccList.map(da => da.replaceAll(',', '')) : [];
      for (const option of this.emailGroupCcList) {
        if (items.includes(option.uuid) && option.emailAddress) {
          const items = option.emailAddress.split('\n')
          for (const item of items) {
            // 去掉;之后 对比是否重复
            const email = item.replaceAll(';', '')
            if (!emails.includes(email)) {
              emails.push(email)
            }
          }
        }
      }
      // 刷新CC内容
      this.refreshCcTxt(emails)
    },
    // 邮件模板改变
    emailTemplateChange(item) {
      const option = this.emailTemplateList.find(p => p.uuid === item)
      this.themeTemplate = option ? option.templateName : ''
      const content = option ? option.contentTemplate : ''
      if (this.showContent) this.emailForm.content = content
      if (!this.showContent) this.tempStr = content

      this.sales = option ? option.sales : ''
      this.op = option ? option.op : ''
      this.csr = option ? option.csr : ''
      this.doc = option ? option.doc : ''
      this.siteOP = option ? option.siteOp : ''
      this.overseaOp = option ? option.overseaOp : ''
      this.planner = option ? option.planner : ''
      this.userDefinedRoleId1 = option ? option.userDefinedRoleId1 : ''
      this.userDefinedRoleId2 = option ? option.userDefinedRoleId2 : ''
      this.emailGroup = option ? option.emailGroup : ''
      this.emailGroupCc = option && option.emailGroupCc ? option.emailGroupCc.split(',') : []

      // 页面联动逻辑
      const ccHandlers = {
        'sales': this.sales,
        'op': this.op,
        'csr': this.csr,
        'doc': this.doc,
        'siteOP': this.siteOP,
        'overseaOp': this.overseaOp,
        'planner': this.planner,
        'userDefinedRoleId1': this.userDefinedRoleId1,
        'userDefinedRoleId2': this.userDefinedRoleId2,
        '': this.emailGroup
      }
      for (const [key, value] of Object.entries(ccHandlers)) {
        this.ccChangeHandler(key, value)
      }

      LocalStorageUtils.setConfiguration(`templateUuid${this.source}`, item)
      LocalStorageUtils.setConfiguration(`themeTemplate${this.source}`, this.themeTemplate)
      this.getSetMailTemplateFunc(item)
    },
    // 主题模板
    titleLabelFunction(item) {
      if(item.templateName){
        return `${item.templateName}`
      }else{
        return ' '
      }
    },
    // 清空抄送人
    onClearCc(val) {
      this.emailGroupCc = ''
      this.emailForm.cc = ''
    },
    // 清空标题
    onClearTitle() {
      this.emailForm.title = ''
      this.emailForm.mailContent = ''
    },
    // 勾选邮件模板
    emailTemplateCheck() {
      if (!this.emailTemplate) {
        this.themeTemplate = ''
      }
      LocalStorageUtils.setConfiguration(`emailTemplate${this.source}`, this.emailTemplate)
    },
    // 设置默认抄送人
    setDefaultCc(defaultContactEmailItem) {
      // 如果是切换了类型，如客户切换到订舱代理. 需要清空之前的联系人抄送列表
      if (this.changeCustomerType || (defaultContactEmailItem && defaultContactEmailItem.ccAddress)) {
        this.clearContactEmailCc()
        if(defaultContactEmailItem && defaultContactEmailItem.ccAddress){
          const emails = defaultContactEmailItem.ccAddress.split(',')
          for (const email of emails) {
            if (!this.ccList.includes(email)) {
              this.ccList.push(email)
              this.contactEmailCc.push(email);
            }
          }
        }
      }
    },
    clearContactEmailCc(){ // 清空之前的联系人抄送列表
      if(this.contactEmailCc && this.contactEmailCc.length > 0){
        for (const email of this.contactEmailCc) {
          this.ccList = this.ccList.filter(value => {
            return value !== email
          })
        }
      }
      // 添加新的联系抄送人
      this.contactEmailCc = []
      if(this.changeCustomerType){
        this.changeCustomerType = false
      }
    }
  }
}
</script>

<style lang="scss">
  .settlement-select-dialog {
    .ag-header {
      display: none;
    }
    .my-custom-quill-editor-send-email .ql-toolbar.ql-snow + .ql-container.ql-snow {
      height: 150px;
      resize: vertical;
      overflow: auto;
    }
  }
  #app #booking-new .booking-details .settlement-select-dialog .el-form-item__content {
    width: auto;
  }
</style>
<style lang="scss" scoped>
.el-radio-group{
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  .el-radio{
    width: 19%;
    height: 26px;
    margin-right: 0;
  }
}
.el-select{
  width: 100% !important;
}
.app-main-inner-row .el-form .el-form-item.placeholder-margin /deep/ .el-form-item__content .el-select__input {
  margin-left: 10px;
}
.el-dialog__body{
  height: 700px;
}
</style>

<style lang="scss">
.ql-toolbar.ql-snow{
  height: 30px;
  padding: 0 !important;
}
</style>
